// src/features/equipment/data/templates.js

export const equipmentTemplates = {
  intraoral_cameras: [
    {
      equipment_type: "INTRAORAL_CAMERA",
      name: "CS 1200 Intraoral Camera",
      manufacturer: "Carestream Dental",
      model: "CS 1200",
      image: "/images/equipment/cs-1200.png",
      max_voltage_kv: null,
      notes: "Entry-level intraoral camera with 6-LED lighting system and 3mm to 25mm focus range"
    },
    {
      equipment_type: "INTRAORAL_CAMERA",
      name: "CS 1500 Intraoral Camera",
      manufacturer: "Carestream Dental",
      model: "CS 1500",
      image: "/images/equipment/cs-1500.png",
      max_voltage_kv: null,
      notes: "Premium intraoral camera with 8-LED lighting system and 1mm to infinity focus range. Resolution 1024x768"
    },
    {
      equipment_type: "INTRAORAL_CAMERA",
      name: "Bonida Dual Alpha Intraoral Camera",
      manufacturer: "Bonida",
      model: "Dual Alpha",
      image: "/images/equipment/bonida-dual-alpha.png",
      max_voltage_kv: null,
      notes: "Dual-camera system with intraoral and extraoral lenses. Liquid lens autofocus, 1280x720 resolution, LED illumination, 5–45mm focus range, measurement mode via long-press capture button."
    },
    {
      equipment_type: "INTRAORAL_CAMERA",
      name: "Bonida HD Pro Intraoral Camera",
      manufacturer: "Bonida",
      model: "HD Pro",
      image: "/images/equipment/bonida-d-cam-hd-s.png",
      max_voltage_kv: null,
      notes: "High-definition intraoral camera offering 1280x720 resolution, improved optics, and enhanced light sensitivity."
    }
  ],
  intraoral_sensors: [
    {
      equipment_type: "INTRAORAL_SENSOR",
      name: "RVG 6200 Sensor",
      manufacturer: "Carestream Dental",
      model: "RVG 6200",
      image: "/images/equipment/cs-rvg-6200.png",
      max_voltage_kv: null,
      notes: "Premium intraoral sensor with 24 lp/mm true image resolution for maximum diagnostic precision"
    },
    {
      equipment_type: "INTRAORAL_SENSOR",
      name: "RVG 5200 Sensor",
      manufacturer: "Carestream Dental",
      model: "RVG 5200",
      image: "/images/equipment/cs-rvg-5200.png",
      max_voltage_kv: null,
      notes: "Basic intraoral sensor with 16 lp/mm true image resolution"
    }
  ],
  intraoral_scanners: [
    {
      equipment_type: "INTRAORAL_SCANNER",
      name: "CS 3600 Intraoral Scanner",
      manufacturer: "Carestream Dental",
      model: "CS 3600",
      image: "/images/equipment/cs-3600.png",
      max_voltage_kv: null,
      notes: "Wired intraoral scanner with high-speed continuous scanning. Dimensions: 220x38x58mm, Weight: 325g"
    },
    {
      equipment_type: "INTRAORAL_SCANNER",
      name: "CS 3700 Intraoral Scanner",
      manufacturer: "Carestream Dental",
      model: "CS 3700",
      image: "/images/equipment/cs-3700.png",
      max_voltage_kv: null,
      notes: "Wired intraoral scanner with turbo-speed scanning and patented smart-shade matching feature"
    },
    {
      equipment_type: "INTRAORAL_SCANNER",
      name: "DEXIS IS 3800W",
      manufacturer: "Dexis",
      model: "IS 3800W",
      image: "/images/equipment/dexis-is-3800w.png",
      max_voltage_kv: null,
      notes: "Trådløs scanner. Scan en hel kæbe på 25 sekunder. Bred dybdeskarphed. En times scanningstid på en enkelt opladning. Ergonomisk design - Red Dot Award vinder"
    },
    {
      equipment_type: "INTRAORAL_SCANNER",
      name: "DEXIS IS 3800",
      manufacturer: "Dexis",
      model: "IS 3800",
      image: "/images/equipment/dexis-is-3800.png",
      max_voltage_kv: null,
      notes: "Kablet scanner. Præcis, hurtig og nem. Vægt kun 190 gram med kabel. Intelligent kabellåsesystem. Plug and play-kabel forenkler brug i praksisser med flere rum"
    },
    {
      equipment_type: "INTRAORAL_SCANNER",
      name: "DEXIS IS 3700",
      manufacturer: "Dexis",
      model: "IS 3700",
      image: "/images/equipment/dexis-is-3700.png",
      max_voltage_kv: null,
      notes: "Turbo-speed scanner designet af Studio F. A. Porsche. Scan en kæbe på 30 sekunder. Ergonomisk optimalt grebsdesign. Valgfri håndledsrem forhindrer utilsigtede fald"
    },
    {
      equipment_type: "INTRAORAL_SCANNER",
      name: "DEXIS IS Voyager",
      manufacturer: "Dexis",
      model: "IS Voyager",
      image: "/images/equipment/dexis-is-voyager.png",
      max_voltage_kv: null,
      notes: "Mobil vogn med alt i én computer. DEXIS IS All in One-computer kan justeres +/- 20°. Skarpt, præcist farvedisplay. Hygiejnisk og praktisk design. Understøtter nuværende og fremtidige DEXIS intraorale scannere"
    },
    {
      equipment_type: "INTRAORAL_SCANNER",
      name: "NewTom IOS 3D Scanner",
      manufacturer: "NewTom",
      model: "IOS 3D",
      image: "/images/equipment/newtomios-3d.png",
      max_voltage_kv: null,
      notes: "Inkl. Notebook 15,6″. Nyeste generation 3D intraoral scanner, ekstremt let og præcis. Integreres med NewTom-instrumenter og kompatibel med hovedsystemer. Ekstremt præcist digitalt indtryk. Undgår manuelt indtryk og invasive handlinger"
    },
    {
      equipment_type: "INTRAORAL_SCANNER",
      name: "Trios 5",
      manufacturer: "3Shape",
      model: "Trios 5",
      image: "/images/equipment/3shape-trios-5.png",
      max_voltage_kv: null,
      notes: ""
    }
  ],
  phosphor_plate_systems: [
    {
      equipment_type: "PHOSPHOR_PLATE_SYSTEM",
      name: "CS 7600 Fosforpladeskanner",
      manufacturer: "Carestream Dental",
      model: "CS 7600",
      image: "/images/equipment/cs-7600.png",
      max_voltage_kv: null,
      notes: "Ægte netværksskanner sender billeder direkte til klinikcomputer. Opløsning: 18 lp/mm (super høj) og 8 lp/mm (hastighed). Scanningstid: ned til 5 sekunder. Automatisk pladeslet. 3,5″ farve LCD display. Ethernet tilslutning. Pladestørrelser: 0-4. Mål: 266,5 x 236,6 x 259,4 mm, Vægt: 6 kg",
      task_templates: [
        "879a4e19-daa4-471f-b120-e0e0612d134c", // Rullerens
      ]
    },
    {
      equipment_type: "PHOSPHOR_PLATE_SYSTEM",
      name: "DIGORA Optime",
      manufacturer: "DIGORA",
      model: "Optime",
      image: "/images/equipment/digora-optime.webp",
      max_voltage_kv: null,
      notes: "Fast, direct digital imaging plate system. Provides images with high detail and excellent contrast"
    },
    {
      equipment_type: "PHOSPHOR_PLATE_SYSTEM",
      name: "DigiSkan Pro",
      manufacturer: "New Life Radiology",
      model: "DigiSkan Pro",
      image: "/images/equipment/digiskan-pro.png",
      max_voltage_kv: null,
      notes: "Scanner på mindre end 5 sekunder. USB 2.0/3.0 og netværkstilslutning. Opløsning: 25 l/p. LED-indikator lyser grønt når klar. Clean Mode for lettere vedligeholdelse. Top-Down Reading optimerer læseoperationer og forhindrer lyseksponering."
    },
    {
      equipment_type: "PHOSPHOR_PLATE_SYSTEM",
      name: "NewTom X-PSP Pladescanner",
      manufacturer: "NewTom",
      model: "X-PSP",
      image: "/images/equipment/newtom-x-psp.png",
      max_voltage_kv: null,
      notes: "Pladescanner til pladestørrelser 0, 1, 2 og 3. Multirum og netværkstilslutning. Mulighed for TWAIN interface. Basic starter KIT DENT"
    },
    {
      equipment_type: "PHOSPHOR_PLATE_SYSTEM",
      name: "VistaScan Mini Plus",
      manufacturer: "Dürr Dental",
      model: "VistaScan Mini Plus",
      image: "/images/equipment/durr-vistascan-mini-plus.png",
      max_voltage_kv: null,
      notes: "Compact image plate scanner for plate sizes 0-4. Up to 22 lp/mm effective resolution, USB and network"
    }
  ],
  cbct_scanners: [
    {
      equipment_type: "CBCT",
      name: "CS 8100 3D CBCT System",
      manufacturer: "Carestream Dental",
      model: "CS 8100 3D",
      image: "/images/equipment/cs-8100-3d.png",
      max_voltage_kv: 90,
      variants: [],
      notes: "Medium FOV CBCT with 2D panoramic. FOV options: 4x4cm to 8x9cm. Ultra-high resolution up to 75 microns",
      task_templates: [
        "152a2ab4-4108-43fc-9357-acee19619a2b", // Konstanskontrol
        "06487e29-ec63-4069-9146-a04f046a5f76", // Eftersyn
      ]
    },
    {
      equipment_type: "CBCT",
      name: "CS 8200 3D",
      manufacturer: "Carestream Dental",
      model: "CS 8200 3D",
      image: "/images/equipment/cs-8200-3d-advance.webp",
      max_voltage_kv: 90,
      variants: [
        { 
          edition: "Access", 
          notes: "4-in-1 CBCT system: panoramic, CBCT, 3D model scanning, optional ceph. FOV up to 12x10cm. 75-micron resolution with CS MAR metal artifact reduction"
        },
        { 
          edition: "Neo", 
          notes: "Enhanced CS 8200 3D with three additional fields of view for greater versatility. Extended FOV feature for full arch scanning including third molars"
        },
        { 
          edition: "Advance", 
          notes: "Latest CS 8200 3D with AI-powered implant planning module. Available in three FOV configurations: 8x9cm, 12x10cm, 16x10cm. Up to 11 FOVs total"
        }
      ],
      notes: "4-in-1 CBCT system with multiple editions available",
      task_templates: [
        "152a2ab4-4108-43fc-9357-acee19619a2b", // Konstanskontrol
        "06487e29-ec63-4069-9146-a04f046a5f76", // Eftersyn
      ]
    },
    {
      equipment_type: "CBCT",
      name: "CS 9600 CBCT System",
      manufacturer: "Carestream Dental",
      model: "CS 9600",
      image: "/images/equipment/cs-9600.png",
      max_voltage_kv: 120,
      notes: "5-in-1 premium CBCT: 2D pano, ceph, CBCT, 3D face scan, 3D model scan. Up to 14 FOV options (4x4cm to 16x17cm)",
      task_templates: [
        "152a2ab4-4108-43fc-9357-acee19619a2b", // Konstanskontrol
        "06487e29-ec63-4069-9146-a04f046a5f76", // Eftersyn
      ]
    },
    {
      equipment_type: "CBCT",
      name: "KaVo ProXam 3D",
      manufacturer: "KaVo",
      model: "ProXam 3D",
      image: "/images/equipment/kavo-proxam-3d.png",
      max_voltage_kv: null,
      notes: "KaVo 3D CBCT system",
      task_templates: [
        "152a2ab4-4108-43fc-9357-acee19619a2b", // Konstanskontrol
        "06487e29-ec63-4069-9146-a04f046a5f76", // Eftersyn
      ]
    },
    {
      equipment_type: "CBCT",
      name: "KaVo ProXam 3DQ",
      manufacturer: "KaVo",
      model: "ProXam 3DQ",
      image: "/images/equipment/kavo-proxam-3dq.png",
      max_voltage_kv: null,
      notes: "KaVo 3D CBCT system with quick scan technology",
      task_templates: [
        "152a2ab4-4108-43fc-9357-acee19619a2b", // Konstanskontrol
        "06487e29-ec63-4069-9146-a04f046a5f76", // Eftersyn
      ]
    },
    {
      equipment_type: "CBCT",
      name: "Dexis OP 3D",
      manufacturer: "Dexis",
      model: "OP 3D",
      image: "/images/equipment/dexis-op-3d.png",
      max_voltage_kv: null,
      notes: "Dexis 3D CBCT system",
      task_templates: [
        "152a2ab4-4108-43fc-9357-acee19619a2b", // Konstanskontrol
        "06487e29-ec63-4069-9146-a04f046a5f76", // Eftersyn
      ]
    },
    {
      equipment_type: "CBCT",
      name: "Dexis OP 3D EX",
      manufacturer: "Dexis",
      model: "OP 3D EX",
      image: "/images/equipment/dexis-op-3d-ex.png",
      max_voltage_kv: null,
      notes: "Dexis 3D CBCT system with extended features",
      task_templates: [
        "152a2ab4-4108-43fc-9357-acee19619a2b", // Konstanskontrol
        "06487e29-ec63-4069-9146-a04f046a5f76", // Eftersyn
      ]
    }
  ],
  panoramic_xray_systems: [
    {
      equipment_type: "PANORAMIC",
      name: "CS 8100 Panoramic System",
      manufacturer: "Carestream Dental",
      model: "CS 8100",
      image: "/images/equipment/cs-8100.png",
      max_voltage_kv: 90,
      notes: "2D panoramic system with Tomosharp technology. Includes standard, pediatric, bitewings, segmented, TMJ views",
      task_templates: [
        "8dacf23c-3c34-4d35-a127-dece927b8b46", // Konstanskontrol
        "06487e29-ec63-4069-9146-a04f046a5f76", // Eftersyn
      ]
    },
    {
      equipment_type: "PANORAMIC",
      name: "CS 8100SC Panoramic + Ceph",
      manufacturer: "Carestream Dental",
      model: "CS 8100SC",
      image: "/images/equipment/cs-8100-sc.png",
      max_voltage_kv: 90,
      notes: "2D panoramic and cephalometric system. 3-second ceph scan time with automatic tracing. Upgradeable to 3D",
      task_templates: [
        "8dacf23c-3c34-4d35-a127-dece927b8b46", // Konstanskontrol
        "06487e29-ec63-4069-9146-a04f046a5f76", // Eftersyn
      ]
    },
    {
      equipment_type: "PANORAMIC",
      name: "KaVo ProXam 2D",
      manufacturer: "KaVo",
      model: "ProXam 2D",
      image: "/images/equipment/kavo-proxam-2d.png",
      max_voltage_kv: null,
      notes: "KaVo 2D panoramic x-ray system",
      task_templates: [
        "8dacf23c-3c34-4d35-a127-dece927b8b46", // Konstanskontrol
        "06487e29-ec63-4069-9146-a04f046a5f76", // Eftersyn
      ]
    },
    {
      equipment_type: "PANORAMIC",
      name: "Dexis OP 2D PAN",
      manufacturer: "Dexis",
      model: "OP 2D PAN",
      image: "/images/equipment/dexis-op-2d-pan.png",
      max_voltage_kv: null,
      notes: "Dexis 2D panoramic x-ray system",
      task_templates: [
        "8dacf23c-3c34-4d35-a127-dece927b8b46", // Konstanskontrol
        "06487e29-ec63-4069-9146-a04f046a5f76", // Eftersyn
      ]
    }
  ],
  xray_generators: [
    {
      equipment_type: "XRAY_GENERATOR_INTRAORAL",
      name: "CS 2100 X-Ray Generator",
      manufacturer: "Carestream Dental",
      model: "CS 2100",
      image: "/images/equipment/cs-2100.png",
      max_voltage_kv: 60,
      notes: "Intraoral X-ray generator"
    },
    {
      equipment_type: "XRAY_GENERATOR_INTRAORAL",
      name: "CS 2200 X-Ray Generator",
      manufacturer: "Carestream Dental",
      model: "CS 2200",
      image: "/images/equipment/cs-2200.png",
      max_voltage_kv: 70,
      notes: "Intraoral X-ray generator"
    },
    {
      equipment_type: "XRAY_GENERATOR_INTRAORAL",
      name: "KaVo ProXam iX",
      manufacturer: "KaVo",
      model: "ProXam iX",
      image: "/images/equipment/kavo-proxam-ix.png",
      max_voltage_kv: null,
      notes: "KaVo intraoral X-ray generator"
    },
    {
      equipment_type: "XRAY_GENERATOR_INTRAORAL",
      name: "FONA XDG Intra Røntgen",
      manufacturer: "FONA",
      model: "XDG",
      image: "/images/equipment/fona_xdg.png",
      max_voltage_kv: 70,
      notes: "Fokuspunkt på 0,4. Forudindstillede eksponeringstider. AC røntgenapparat."
    },
    {
      equipment_type: "XRAY_GENERATOR_INTRAORAL",
      name: "BEST DC Touch",
      manufacturer: "BEST",
      model: "DC Touch",
      image: "/images/equipment/best-dc-touch.png",
      max_voltage_kv: 70,
      notes: "4-7 mA DC generator med 60 cm vandret arm. 0,3 mm focus punkt. Trådløs fjernbetjening. 230 volt tilslutning."
    },
    {
      equipment_type: "XRAY_GENERATOR_INTRAORAL",
      name: "NewTom RXDC Trådløs",
      manufacturer: "NewTom",
      model: "RXDC Wireless",
      image: "/images/equipment/newtom-rxdc-wireless.png",
      max_voltage_kv: 70,
      notes: "8mA DC generator med 60cm vandret arm. Fokuspunkt 0,4 mm. Integreret selvbalanceringssystem."
    },
    {
      equipment_type: "XRAY_GENERATOR_INTRAORAL",
      name: "NewTom RXDC",
      manufacturer: "NewTom",
      model: "RXDC Wired",
      image: "/images/equipment/newtom-rxdc-wired.png",
      max_voltage_kv: 70,
      notes: "8mA DC generator med 60cm vandret arm. Fokuspunkt 0,4 mm. Integreret selvbalanceringssystem."
    },
    {
      equipment_type: "XRAY_GENERATOR_INTRAORAL",
      name: "EVOSTYLE",
      manufacturer: "EVOSTYLE",
      model: "EVOSTYLE",
      image: "/images/equipment/evo-style-hovede.png",
      max_voltage_kv: 70,
      notes: "8 mA AC generator med 60 cm vandret arm. 0,8 mm fokus punkt. 230 volt tilslutning til timer."
    },
    {
      equipment_type: "XRAY_GENERATOR_INTRAORAL",
      name: "Gendex Oralix",
      manufacturer: "Gendex",
      model: "Oralix",
      image: "/images/equipment/gendex-oralix-65.png",
      max_voltage_kv: 65,
      notes: ""
    },
    {
      equipment_type: "XRAY_GENERATOR_INTRAORAL",
      name: "Sirona Vario",
      manufacturer: "Sirona",
      model: "Vario",
      image: "/images/equipment/sirona-vario-dg.png",
      max_voltage_kv: 70,
      notes: ""
    },
    {
      equipment_type: "XRAY_GENERATOR_INTRAORAL",
      name: "Dexis Focus",
      manufacturer: "Dexis",
      model: "Focus",
      image: "/images/equipment/dexis-focus.png",
      max_voltage_kv: 70,
      notes: ""
    },
    {
      equipment_type: "XRAY_GENERATOR_INTRAORAL",
      name: "Planmeca Intra",
      manufacturer: "Planmeca",
      model: "Intra",
      image: "/images/equipment/planmeca-intra.png",
      max_voltage_kv: 70,
      notes: "Intraoral X-ray unit, 50-70 kV and 2-8 mA. Superseded by Planmeca ProX"
    }
  ],
  treatment_units: [
    {
      equipment_type: "UNIT",
      name: "KaVo uniQa",
      manufacturer: "KaVo",
      model: "uniQa",
      image: "/images/equipment/kavo-uniqa.png",
      max_voltage_kv: null,
      notes: "KaVo treatment unit"
    },
    {
      equipment_type: "UNIT",
      name: "KaVo amiQa",
      manufacturer: "KaVo",
      model: "amiQa",
      image: "/images/equipment/kavo-amiqa.png",
      max_voltage_kv: null,
      notes: "KaVo treatment unit"
    },
    {
      equipment_type: "UNIT",
      name: "KaVo 1058 Life",
      manufacturer: "KaVo",
      model: "1058 Life",
      image: "/images/equipment/kavo-1058-life.png",
      max_voltage_kv: null,
      notes: "KaVo treatment unit"
    },
    {
      equipment_type: "UNIT",
      name: "KaVo E50",
      manufacturer: "KaVo",
      model: "E50",
      image: "/images/equipment/kavo-e50.png",
      max_voltage_kv: null,
      notes: "KaVo treatment unit"
    },
    {
      equipment_type: "UNIT",
      name: "KaVo E70/E80",
      manufacturer: "KaVo",
      model: "E70/E80",
      image: "/images/equipment/kavo-e70.png",
      max_voltage_kv: null,
      variants: [
        {
          edition: "E70",
          notes: "KaVo treatment unit"
        },
        {
          edition: "E80",
          notes: "KaVo treatment unit"
        }
      ],
      notes: "KaVo treatment unit series"
    },
    {
      equipment_type: "UNIT",
      name: "Heka S+",
      manufacturer: "Heka",
      model: "S+",
      image: "/images/equipment/heka-s-plus.png",
      max_voltage_kv: null,
      notes: "Heka treatment unit"
    },
    {
      equipment_type: "UNIT",
      name: "Heka UnicLine S",
      manufacturer: "Heka",
      model: "UnicLine S",
      image: "/images/equipment/heka-unicline-s.png",
      max_voltage_kv: null,
      notes: "Heka treatment unit"
    },
    {
      equipment_type: "UNIT",
      name: "Heka UNIC",
      manufacturer: "Heka",
      model: "UNIC",
      image: "/images/equipment/heka-unic.png",
      max_voltage_kv: null,
      notes: "Heka treatment unit"
    },
    {
      equipment_type: "UNIT",
      name: "Heka UnicLine",
      manufacturer: "Heka",
      model: "UnicLine",
      image: "/images/equipment/heka-unicline.png",
      max_voltage_kv: null,
      notes: "Heka treatment unit"
    },
    {
      equipment_type: "UNIT",
      name: "Planmeca Compact i",
      manufacturer: "Planmeca",
      model: "Compact i",
      image: "/images/equipment/planmeca-compact-i.png",
      max_voltage_kv: null,
      notes: "Planmeca treatment unit with integrated touch panel"
    }
  ],
  autoclaves: [
    {
      equipment_type: "AUTOCLAVE",
      name: "Melag ProLine",
      manufacturer: "Melag",
      model: "ProLine",
      image: "/images/equipment/melag-proline.png",
      max_voltage_kv: null,
      variants: [
        {
          edition: "118 B",
          notes: "Pro & Prime Line series autoclave"
        },
        {
          edition: "123 B",
          notes: "Pro & Prime Line series autoclave"
        }
      ],
      notes: "Melag Pro & Prime Line autoclaves"
    },
    {
      equipment_type: "AUTOCLAVE",
      name: "Melag Prime Line",
      manufacturer: "Melag",
      model: "Prime Line",
      image: "/images/equipment/melag-primeline.png",
      max_voltage_kv: null,
      variants: [
        {
          edition: "318 B",
          notes: "Pro & Prime Line series autoclave"
        },
        {
          edition: "323 B",
          notes: "Pro & Prime Line series autoclave"
        }
      ],
      notes: "Melag Pro & Prime Line autoclaves"
    },
    {
      equipment_type: "AUTOCLAVE",
      name: "Melag Vacuklav",
      manufacturer: "Melag",
      model: "Vacuklav",
      image: "/images/equipment/melag-vacuklav.png",
      max_voltage_kv: null,
      variants: [
        {
          edition: "41 B+",
          notes: "Premium class autoclave"
        },
        {
          edition: "43 B+",
          notes: "Premium class autoclave"
        },
        {
          edition: "40 B+",
          notes: "Premium class autoclave"
        },
        {
          edition: "44 B+",
          notes: "Premium class autoclave"
        }
      ],
      notes: "Melag Premium class Vacuklav autoclaves"
    },
    {
      equipment_type: "AUTOCLAVE",
      name: "Melag Vacuclave 550",
      manufacturer: "Melag",
      model: "Vacuclave 550",
      image: "/images/equipment/melag-vacuclave-550.png",
      max_voltage_kv: null,
      notes: "Premium class extra-large autoclave (ekstra stor)"
    },
    {
      equipment_type: "AUTOCLAVE",
      name: "Melag SteriHero Vet",
      manufacturer: "Melag",
      model: "SteriHero Vet",
      image: "/images/equipment/melag-sterihero-vet.png",
      max_voltage_kv: null,
      notes: "Premium class veterinary autoclave"
    },
    {
      equipment_type: "AUTOCLAVE",
      name: "Melag Cliniklav 45",
      manufacturer: "Melag",
      model: "Cliniklav 45",
      image: "/images/equipment/melag-cliniklav-45.png",
      max_voltage_kv: null,
      notes: "Melag Cliniklav series autoclave"
    },
    {
      equipment_type: "AUTOCLAVE",
      name: "Melag Careclave",
      manufacturer: "Melag",
      model: "Careclave",
      image: "/images/equipment/melag-careclave.png",
      max_voltage_kv: null,
      notes: "Melag Careclave autoclave"
    },
    {
      equipment_type: "AUTOCLAVE",
      name: "Melag MELAtherm",
      manufacturer: "Melag",
      model: "MELAtherm",
      image: "/images/equipment/melag-melatherm.png",
      max_voltage_kv: null,
      variants: [
        {
          edition: "20",
          notes: "MELAtherm series washer-disinfector"
        },
        {
          edition: "10 Evolution",
          notes: "MELAtherm series washer-disinfector"
        }
      ],
      notes: "Melag MELAtherm washer-disinfector series"
    },
    {
      equipment_type: "AUTOCLAVE",
      name: "DAC Universal",
      manufacturer: "Sirona",
      model: "DAC Universal",
      image: "/images/equipment/sirona-dac-universal.png",
      max_voltage_kv: null,
      notes: "DAC"
    },
    {
      equipment_type: "AUTOCLAVE",
      name: "W&H Lisa 17",
      manufacturer: "W&H",
      model: "Lisa 17",
      image: "/images/equipment/wh-lisa-17.png",
      max_voltage_kv: null,
      notes: "Class B vacuum steam steriliser with a 17 litre chamber"
    },
  ],
  dishwashers: [
    {
      equipment_type: "DISHWASHER",
      name: "Miele Dental PWD 8682",
      manufacturer: "Miele",
      model: "PWD 8682",
      image: "/images/equipment/miele-pwd-8682.png",
      max_voltage_kv: null,
      notes: "Miele dental washer-disinfector"
    },
    {
      equipment_type: "DISHWASHER",
      name: "Opvaskemaskine",
      manufacturer: "Miele",
      model: "Dishwasher small",
      image: "/images/equipment/meile-dishwasher-small.png",
      max_voltage_kv: null,
      notes: "Miele kitchen dishwasherwasher"
    },
    {
      equipment_type: "DISHWASHER",
      name: "Miele G 7881",
      manufacturer: "Miele",
      model: "G 7881",
      image: "/images/equipment/miele-g-7881.png",
      max_voltage_kv: null,
      notes: "Miele dental thermal washer-disinfector"
    }
  ],
  refrigerators: [
    {
      equipment_type: "REFRIGERATOR",
      name: "Køleskab",
      manufacturer: null,
      model: "Fridge",
      image: "/images/equipment/fridge.png",
      max_voltage_kv: null,
      notes: "Standard refrigerator"
    },
    {
      equipment_type: "REFRIGERATOR",
      name: "Materiale Køleskab",
      manufacturer: null,
      model: "Industrial Fridge",
      image: "/images/equipment/industrial-fridge.png",
      max_voltage_kv: null,
      notes: "Material refrigerator"
    }
  ],
  washing_machines: [
    {
      equipment_type: "WASHING_MACHINE",
      name: "Miele W1 Vaskemaskine",
      manufacturer: "Miele",
      model: "W1",
      image: "/images/equipment/miele-w1.png",
      max_voltage_kv: null,
      notes: "Miele W1 washing machine"
    },
    {
      equipment_type: "WASHING_MACHINE",
      name: "Electrolux W555H Vaskemaskine",
      manufacturer: "Electrolux",
      model: "W555H",
      image: "/images/equipment/electrolux-w555h.png",
      max_voltage_kv: null,
      notes: "Electrolux Professional 6 kg washer extractor"
    }
  ],
  ultrasonic_cleaners: [
    {
      equipment_type: "ULTRASONIC_CLEANER",
      name: "Ultralydskar",
      manufacturer: "BioSonic",
      model: "UC50DB",
      image: "/images/equipment/biosonic-uc50bd.png",
      max_voltage_kv: null,
      notes: "Ultrasonic cleaning bath"
    }
  ],
  anesthesia_apparatus: [
    {
      equipment_type: "ANESTHESIA_APPARATUS",
      name: "Narkose Apparat",
      manufacturer: null,
      model: "Anesthesia apparatus",
      image: "/images/equipment/anesthesia-pump.png",
      max_voltage_kv: null,
      notes: "Anesthesia apparatus"
    }
  ],
  compressors: [
    {
      equipment_type: "COMPRESSOR",
      name: "Kompressor",
      manufacturer: "Dürr Dental",
      model: "Trio",
      image: "/images/equipment/durr-trio.png",
      max_voltage_kv: null,
      notes: ""
    },
  ],
  suction_motors: [
    {
      equipment_type: "SUCTION_MOTOR",
      name: "V1200S Sugemotor",
      manufacturer: "Dürr Dental",
      model: "V1200S",
      image: "/images/equipment/durr-v1200s.png",
      max_voltage_kv: null,
      notes: "Suction motor"
    },
    {
      equipment_type: "SUCTION_MOTOR",
      name: "Opsamlespand Sugemotor",
      manufacturer: null,
      model: "Opsamlespand",
      image: "/images/equipment/collection-bucket-suction-motor.png",
      max_voltage_kv: null,
      notes: "Collection bucket suction motor"
    }
  ],
  dryers: [
    {
      equipment_type: "DRYER",
      name: "Samsung Tørremaskine",
      manufacturer: "Samsung",
      model: "Samsung Tørremaskine",
      image: "/images/equipment/samsung-dryer.png",
      max_voltage_kv: null,
      notes: "Samsung dryer"
    }
  ],
  incubators: [
    {
      equipment_type: "INCUBATOR",
      name: "Inkubator",
      manufacturer: "Attest",
      model: "Autoreader 490",
      image: "/images/equipment/attest-autoreader-490.png",
      max_voltage_kv: null,
      notes: "Incubator"
    }
  ],
  light_curing_lamps: [
    {
      equipment_type: "LIGHT_CURING_LAMP",
      name: "Lyspolymeriseringslampe",
      manufacturer: null,
      model: "Light Curing Lamp",
      image: "/images/equipment/polymeriseringslampe.png",
      max_voltage_kv: null,
      notes: "Lyspolymeriseringslampe til hærdning af kompositmaterialer"
    }
  ],
  milling_units: [
    {
      equipment_type: "OTHER",
      name: "Planmeca PlanMill 40",
      manufacturer: "Planmeca",
      model: "PlanMill 40",
      image: "/images/equipment/planmeca-planmill-40.png",
      max_voltage_kv: null,
      notes: "Chairside milling unit for CAD/CAM restorations"
    }
  ]
};

export const familyLabels = {
  intraoral_cameras: "Intraoral Cameras",
  intraoral_sensors: "Intraoral Sensors",
  intraoral_scanners: "Intraoral Scanners",
  cbct_scanners: "CBCT Scanners",
  panoramic_xray_systems: "Panoramic X-Ray Systems",
  xray_generators: "X-Ray Generators",
  phosphor_plate_systems: "Phosphor Plate Systems",
  treatment_units: "Treatment Units",
  autoclaves: "Autoclaves",
  dishwashers: "Dishwashers",
  refrigerators: "Refrigerators",
  washing_machines: "Washing Machines",
  ultrasonic_cleaners: "Ultrasonic Cleaners",
  anesthesia_apparatus: "Anesthesia Apparatus",
  suction_motors: "Suction Motors",
  dryers: "Dryers",
  incubators: "Incubators",
  light_curing_lamps: "Light Curing Lamps",
  milling_units: "Milling Units"
};